export const LOADING_SERVICEREQUESTS = "LOADING_SERVICEREQUESTS";
export const GET_SERVICEREQUESTS_LIST = "GET_SERVICEREQUESTS_LIST";
export const REMOVE_SERVICEREQUESTS = "REMOVE_SERVICEREQUESTS";
export const ADD_SERVICEREQUESTS = "ADD_SERVICEREQUESTS";
export const UPDATE_SERVICEREQUESTS = "UPDATE_SERVICEREQUESTS";
export const GET_SERVICEREQUESTSBYID = "GET_SERVICEREQUESTSBYID";
export const GET_SERVICEREQUESTSBYREFERENCENO = "GET_SERVICEREQUESTSBYREFERENCENO";
export const RESCHEDULE_SERVICEREQUESTS = "RESCHEDULE_SERVICEREQUESTS";
export const APPROVE_OR_CANCEL_SERVICEREQUESTS = "APPROVE_OR_CANCEL_SERVICEREQUESTS";
export const GET_STAFFSERVICEREQUESTS_LIST = "GET_STAFFSERVICEREQUESTS_LIST";


export const LOADING_SERVICEORDERREQUESTS = "LOADING_SERVICEORDERREQUESTS";
export const GET_SERVICEORDERREQUESTS_LIST = "GET_SERVICEORDERREQUESTS_LIST";
export const REMOVE_SERVICEORDERREQUESTS = "REMOVE_SERVICEORDERREQUESTS";
export const ADD_SERVICEORDERREQUESTS = "ADD_SERVICEORDERREQUESTS";
export const UPDATE_SERVICEORDERREQUESTS = "UPDATE_SERVICEORDERREQUESTS";
export const GET_SERVICEORDERREQUESTSBYID = "GET_SERVICEORDERREQUESTSBYID";
export const ADD_SERVICEORDERREQUESTSSIGNATURE = "ADD_SERVICEORDERREQUESTSSIGNATURE";
export const GET_SERVICEORDERREQUESTSSIGNATURE = "GET_SERVICEORDERREQUESTSSIGNATURE";
export const GET_SERVICEORDERREQUESTSAPPROVEORCANCEL = "GET_SERVICEORDERREQUESTSAPPROVEORCANCEL";
export const GET_SERVICEORDERREQUESTSRESCHEDULE = "GET_SERVICEORDERREQUESTSRESCHEDULE";

export const SERVICEDOCUMENT_LOADING_FILE = "SERVICEDOCUMENT_LOADING_FILE";
export const SERVICEDOCUMENT_ADD_FILE = "SERVICEDOCUMENT_ADD_FILE";
export const SERVICEDOCUMENT_UPDATE_FILE = "SERVICEDOCUMENT_UPDATE_FILE";
export const SERVICEDOCUMENT_GET_FILE_LIST = "SERVICEDOCUMENT_GET_FILE_LIST";
export const SERVICEDOCUMENT_GET_FILE = "SERVICEDOCUMENT_GET_FILE";

export const SERVICEORDERDOCUMENT_LOADING_FILE = "SERVICEORDERDOCUMENT_LOADING_FILE";
export const SERVICEORDERDOCUMENT_ADD_FILE = "SERVICEORDERDOCUMENT_ADD_FILE";
export const SERVICEORDERDOCUMENT_UPDATE_FILE = "SERVICEORDERDOCUMENT_UPDATE_FILE";
export const SERVICEORDERDOCUMENT_GET_FILE_LIST = "SERVICEORDERDOCUMENT_GET_FILE_LIST";
export const SERVICEORDERDOCUMENT_GET_FILE = "SERVICEORDERDOCUMENT_GET_FILE";


export const SERVICEORDER_TIMESHEET_LOADING = "SERVICEORDER_TIMESHEET_LOADING";
export const SERVICEORDER_ADD_TIMESHEET = "SERVICEORDER_ADD_TIMESHEET";
export const SERVICEORDER_UPDATE_TIMESHEET = "SERVICEORDER_UPDATE_TIMESHEET";
export const SERVICEORDER_GET_TIMESHEET = "SERVICEORDER_GET_TIMESHEET";
export const SERVICEORDER_GET_TIMESHEET_LIST = "SERVICEORDER_GET_TIMESHEET_LIST";

export const LOADING_DOCUMENT = "LOADING_DOCUMENT";
export const REMOVE_DOCUMENT = "REMOVE_DOCUMENT";
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const ADD_MULTI_DOCUMENT = "ADD_MULTI_DOCUMENT";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const GET_DOCUMENT_LIST = "GET_DOCUMENT_LIST";
export const FILE_SHARING = "FILE_SHARING";
export const IMPORT_TIMESHEET = "IMPORT_TIMESHEET";
export const REMOVE_ORDER_DOCUMENT = "REMOVE_ORDER_DOCUMENT";